var spoiler_default = {
  "fontElementMap": "le-1E",
  "hideText": "ptr7v",
  "onHoverText": "KkvAh",
  "hideBlock": "ATUKV",
  "smallBlur": "FwVTd",
  "mediumBlur": "LJ6cg",
  "largeBlur": "pZVEr",
  "hideBlock_gallery": "_3KCZp",
  "overlay": "VKMqV",
  "overlay_gallery": "nnJxT",
  "revealSpoilerBtn": "dQMb2",
  "isMobile": "R7XkH",
  "onHoverBtn": "aKnWU",
  "spoilerWrapper": "lP9xn",
  "spoilerDescription": "_1pacr",
  "spoilerContainer": "RbbDM",
  "spoilerContainer_Gallery": "C-uyo"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
